<div
    class="betslip betslip-edit-bet"
    *ngIf="betslipState$ | async as betslipState"
    [ngClass]="{ 'edit-bet-in-progress': isEditBetInProgress(betslipState) }">
    <div class="betslip-edit-bet_ui-lock-veil" *ngIf="isEditBetInProgress(betslipState)"></div>
    <bs-betslip-edit-mybet-header></bs-betslip-edit-mybet-header>
    <bs-betslip-edit-mybet-add-selection></bs-betslip-edit-mybet-add-selection>
    <div
        class="betslip-edit-bet__container"
        [ngClass]="{
            'edit-bet__container--add-picks-visible': betslipState.types.editBet.addPicksState.isVisible,
        }">
        <div class="betslip-edit-bet__picks-area">
            <bs-edit-bet-pick-container></bs-edit-bet-pick-container>
        </div>
        <div class="betslip-edit-bet_bottom-notifications-container">
            <bs-betslip-edit-my-bet-bottom-message></bs-betslip-edit-my-bet-bottom-message>
            <bs-betslip-bet-errors></bs-betslip-bet-errors>
        </div>
        <bs-edit-bet-add-picks-container-desktop></bs-edit-bet-add-picks-container-desktop>
    </div>
    <div class="betslip-edit-bet__summary-container">
        <bs-betslip-edit-mybet-summary [inColumn]="inColumn"></bs-betslip-edit-mybet-summary>
    </div>
</div>
